import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import DashboardShell from "@/components/DashboardShell";
import ChatThread from "@/components/ChatThread";
import { EmptyState, Spinner } from "@/components/States";
import { MessageSquare, User } from "lucide-react";

const FILTERS = [
  { label: "Open", value: "open" },
  { label: "In Progress", value: "in_progress" },
  { label: "All", value: "all" },
];
const STATUS_COLOR = { open: "bg-amber-soft text-amber-warm", in_progress: "bg-blue-50 text-blue-600", resolved: "bg-brand-soft text-brand", closed: "bg-slate-100 text-slate-500" };

export default function SupportAgentDashboard() {
  const [filter, setFilter] = useState("open");
  const [active, setActive] = useState(null);
  const { data: tickets, isLoading } = useQuery({
    queryKey: ["agent-tickets", filter],
    queryFn: () => api.get("/agent/tickets", { params: { status: filter } }).then((r) => r.data),
    refetchInterval: 5000,
  });

  return (
    <DashboardShell title="Support Console" roleColor="#0EA5E9" roleLabel="Support">
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
        {/* Conversation list */}
        <div className="lg:col-span-1">
          <div className="mb-3 flex gap-2">
            {FILTERS.map((f) => (
              <button key={f.value} data-testid={`agent-filter-${f.value}`} onClick={() => setFilter(f.value)}
                className={`rounded-full px-3 py-1.5 text-xs font-semibold ${filter === f.value ? "bg-[#0EA5E9] text-white" : "border border-slate-200 bg-white text-slate-600"}`}>{f.label}</button>
            ))}
          </div>
          <div className="space-y-2">
            {isLoading ? <Spinner /> : tickets?.length ? tickets.map((t) => (
              <button key={t.id} data-testid="agent-ticket-item" onClick={() => setActive(t.id)}
                className={`w-full rounded-2xl border p-3 text-left transition-all ${active === t.id ? "border-[#0EA5E9] bg-sky-50" : "border-slate-200 bg-white hover:border-[#0EA5E9]/40"}`}>
                <div className="flex items-center justify-between">
                  <p className="truncate font-semibold text-slate-800">{t.subject}</p>
                  <span className={`shrink-0 rounded-md px-1.5 py-0.5 text-[10px] font-bold ${STATUS_COLOR[t.status]}`}>{t.status.replace(/_/g, " ")}</span>
                </div>
                <p className="flex items-center gap-1 text-xs text-slate-500"><User className="h-3 w-3" /> {t.customer_name} · {t.messages?.length || 0} msgs</p>
              </button>
            )) : <EmptyState icon={MessageSquare} title="No conversations" subtitle="New customer chats appear here." />}
          </div>
        </div>

        {/* Chat panel */}
        <div className="lg:col-span-2">
          <div className="h-[70vh] overflow-hidden rounded-2xl border border-slate-200 bg-white">
            {active ? <ChatThread ticketId={active} mode="agent" />
              : <div className="flex h-full flex-col items-center justify-center text-center text-slate-400"><MessageSquare className="mb-3 h-10 w-10" /><p className="text-sm">Select a conversation to start chatting</p></div>}
          </div>
        </div>
      </div>
    </DashboardShell>
  );
}
